module.exports = require('./generateContextHook')
